module.exports = __webpack_public_path__ + "img/weiyun.6449c15d.svg";